import { api } from './api'
import { Drug, DrugSearchFilters, DrugSyncStatus } from '../types/drug'

export const drugService = {
  /**
   * Get all drugs with optional filters
   */
  getAll: async (filters?: DrugSearchFilters): Promise<Drug[]> => {
    const params = new URLSearchParams()
    if (filters?.search) params.append('search', filters.search)
    if (filters?.productType) params.append('productType', filters.productType)
    if (filters?.marketInfo) params.append('marketInfo', filters.marketInfo)
    if (filters?.registrationStatus) params.append('registrationStatus', filters.registrationStatus)
    if (filters?.dosageForm) params.append('dosageForm', filters.dosageForm)
    if (filters?.atc) params.append('atc', filters.atc)
    if (filters?.activeSubstance) params.append('activeSubstance', filters.activeSubstance)
    if (filters?.isWithdrawn !== undefined) params.append('isWithdrawn', String(filters.isWithdrawn))
    if (filters?.isInterchangeable !== undefined) params.append('isInterchangeable', String(filters.isInterchangeable))

    const queryString = params.toString()
    const url = queryString ? `/drugs?${queryString}` : '/drugs'
    const response = await api.get<Drug[]>(url)
    return response.data
  },

  /**
   * Get a single drug by ID
   */
  getById: async (id: string): Promise<Drug> => {
    const response = await api.get<Drug>(`/drugs/${id}`)
    return response.data
  },

  /**
   * Get drug by DrugIDPK (HPRA identifier)
   */
  getByDrugIdPK: async (drugIdPK: string): Promise<Drug> => {
    const response = await api.get<Drug>(`/drugs/by-drug-id/${drugIdPK}`)
    return response.data
  },

  /**
   * Search drugs by name or code
   */
  search: async (searchTerm: string): Promise<Drug[]> => {
    const response = await api.get<Drug[]>(`/drugs/search?q=${encodeURIComponent(searchTerm)}`)
    return response.data
  },

  /**
   * Get sync status
   */
  getSyncStatus: async (): Promise<DrugSyncStatus> => {
    const response = await api.get<DrugSyncStatus>('/drugs/sync-status')
    return response.data
  },

  /**
   * Trigger drug data sync from HPRA
   */
  syncFromHPRA: async (): Promise<{ message: string; status: string }> => {
    const response = await api.post<{ message: string; status: string }>('/drugs/sync')
    return response.data
  },
}



































